export let gallerys = [
  { id: 1, image: "/images/gallery1.png" },
  { id: 2, image: "/images/gallery2.png" },
  { id: 3, image: "/images/gallery3.png" },
  { id: 4, image: "/images/gallery4.png" },
];
